import "../styles/MainContainer.scss";

function MainContainer({ children }: any) {
    return <main className="main-container">{children}</main>;
}

export default MainContainer;
